import styled from 'styled-components';

import { DeleteButton } from 'components/specified-buttons';

export const StyledDeleteButton = styled(DeleteButton)`
  margin-top: 32px;
`;
